type Props = {
  onClick?: any;
  buttoncss?: any;
  outerClass?: any;
  buttonClass?: any;
  disabledcss?: any;
  className?: any;
  color?: any;
  icon?: any;
  text?: any;
  children?: any;
  hovertext?: any;
  bordersize?: any;
  hoverbg?: any;
  hoverbordercolor?: any;
  justify?: any;
  margin?: any;
  padding?: any;
  disabled?: boolean;
};
const Button = ({
  onClick,
  padding,
  className,
  color,
  buttoncss,
  outerClass,
  buttonClass,
  disabledcss,
  text,
  hovertext,
  bordersize,
  hoverbg,
  justify,
  margin,
  disabled = false,
}: Props) => {
  return (
    <>
      <div className={`${outerClass} flex w-full ${margin} ${justify}`}>
        <button
          onClick={onClick}
          disabled={disabled}
          type="submit"
          className={`${buttonClass} ${buttoncss} rounded-lg
                                    font-bold
                        ${disabledcss}
                        ${hoverbg}
                        ${bordersize}
                        ${padding}
                        ${hovertext}
                        text-white
                        cursor-pointer
                        `}
        >
          {text}
        </button>
      </div>
    </>
  );
};

Button.defaultProps = {
  color: "rose",
  className: "w-full text-gray-900",
  hovertext: "hover:text-white",
  outerClass: "",
  buttonClass: "",
  buttoncss: "bg-[#ff39b3] font-bold",
  disabledcss: "disabled:bg-gray-400",
  bordersize: "border-2",
  hoverbg: "hover:bg-navy",
  justify: "justify-end",
  margin: "mt-4",
  padding: "py-2.5 px-6",
};

export { Button };
